import { render, staticRenderFns } from "./employes.vue?vue&type=template&id=0388044a&"
import script from "./employes.vue?vue&type=script&lang=js&"
export * from "./employes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports